import "@/App.css";
import { useEffect } from "react";
import { api, applyTheme } from "@/lib/api";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AmbientBackground } from "@/components/AmbientBackground";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import BoaDetail from "@/pages/BoaDetail";
import Genetics from "@/pages/Genetics";
import Social from "@/pages/Social";
import NewsletterPage from "@/pages/NewsletterPage";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function Chrome({ children }) {
  const { pathname } = useLocation();
  const bare = pathname.startsWith("/admin");
  const dark = pathname !== "/shop" && !bare;
  useEffect(() => {
    const siteUrl = process.env.REACT_APP_SITE_URL;
    if (!siteUrl) return;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${siteUrl}${pathname}`);
  }, [pathname]);
  return (
    <>
      {dark && <AmbientBackground />}
      {!bare && <Nav />}
      {children}
      {!bare && <Footer />}
    </>
  );
}

function App() {
  useEffect(() => { api.get("/settings").then((r) => applyTheme(r.data)).catch(() => {}); }, []);
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Chrome>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/projects/:slug" element={<ProjectDetail />} />
                <Route path="/boa/:id" element={<BoaDetail />} />
                <Route path="/genetics" element={<Genetics />} />
                <Route path="/social" element={<Social />} />
                <Route path="/newsletter" element={<NewsletterPage />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              </Routes>
            </Chrome>
          </SmoothScroll>
          <Toaster theme="dark" position="bottom-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
